export default {"src":"/_next/static/media/Thoracotomy.e204eea4.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};